jQuery(function($){
  if ($('.contact-form-js').length){
    $('.professional-js').on('change', function(){
      if ($(this).is(':checked')){
        $('.not-for-pros-js').each(function(){
          $(this).hide();
          $(this).find('input').attr('disabled', 'disabled');
        });
      }
      else{
        $('.not-for-pros-js').each(function(){
          $(this).show();
          $(this).find('input').removeAttr('disabled');
        });
      }
    });
    $('.professional-js').trigger('change');
  }
});